<template>
  <DashboardPanel
    panel-id="v-pills-education"
    aria-labelledby="v-pills-education-tab"
    title="Education"
    subtitle="Qualifications from highest degree through school"
  >
    <div class="hc-panel__section">
      <div class="hc-panel__section-head">
        <h3>Highest qualification</h3>
        <ProfileActionBtn variant="edit" id="ij" @click="editHighQualification">Edit</ProfileActionBtn>
      </div>
      <div class="hc-panel__section-body hc-profile-details">
        <form @submit="updateHighestQualification">
          <div id="i" v-if="!edit_highQualification">
            <ProfileDetailGrid>
              <ProfileDetailItem label="Course" :value="highest_education.course_id ? getCourse(highest_education.course_id) : ''" required />
              <ProfileDetailItem label="Specification" :value="highest_education.specification ? getSpecification(highest_education.specification) : ''" required />
              <ProfileDetailItem label="State" :value="highest_education.state_id ? getState(highest_education.state_id) : ''" required />
              <ProfileDetailItem label="College" :value="highest_education.institute_id ? getInstitute(highest_education.institute_id) : ''" required />
              <ProfileDetailItem label="Course type" :value="highest_education.course_type ? getCourseType(highest_education.course_type) : ''" required />
              <ProfileDetailItem label="Passing year" :value="highest_education.passout_year" required />
              <ProfileDetailItem label="Marks" :value="highest_education.mark ? `${highest_education.mark}%` : ''" required />
            </ProfileDetailGrid>
          </div>
          <div id="j" class="hc-profile-edit-form" v-if="edit_highQualification">
            <ProfileDetailGrid>
              <ProfileEditItem
                label="Course"
                required
                :error="(typeof validate.response.highest_course != 'undefined' && !validate.response.highest_course.val) ? validate.response.highest_course.msg : ''"
              >
                <v-autocomplete
                  v-model="highest_education.course_id"
                  :searchable="true"
                  :items="courses"
                  item-text="text"
                  item-value="id"
                  placeholder="Course"
                  @change="getSpecifications"
                  @input="validate.checkIfEmpty(highest_education.course_id, 'highest_course', 'Enter course')"
                  outlined
                  dense
                  hide-details
                >
                  <template slot="item" slot-scope="data">
                    <template>
                      <v-list-item-content>{{ data.item.text }}</v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </ProfileEditItem>
              <ProfileEditItem
                label="Specification"
                required
                :error="(typeof validate.response.highest_speci != 'undefined' && !validate.response.highest_speci.val) ? validate.response.highest_speci.msg : ''"
              >
                <v-autocomplete
                  id="label-specialisation"
                  v-model="highest_education.specification"
                  :items="spec"
                  item-value="value"
                  item-text="text"
                  placeholder="Specification"
                  @input="validate.checkIfEmpty(highest_education.specification, 'highest_speci', 'Enter specification')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="State"
                required
                :error="(typeof validate.response.highest_state != 'undefined' && !validate.response.highest_state.val) ? validate.response.highest_state.msg : ''"
              >
                <v-autocomplete
                  v-model="highest_education.state_id"
                  :items="states"
                  item-text="text"
                  item-value="id"
                  placeholder="State"
                  @change="getInstitutes"
                  @input="validate.checkIfEmpty(highest_education.state_id, 'highest_state', 'Enter state')"
                  clearable
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="College"
                required
                :error="(typeof validate.response.highest_university != 'undefined' && !validate.response.highest_university.val) ? validate.response.highest_university.msg : ''"
              >
                <v-autocomplete
                  id="label-universities"
                  v-model="highest_education.institute_id"
                  :items="institutes"
                  item-value="value"
                  item-text="text"
                  placeholder="College"
                  @input="validate.checkIfEmpty(highest_education.institute_id, 'highest_university', 'Select college')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="Course type"
                required
                :error="(typeof validate.response.highest_course_type != 'undefined' && !validate.response.highest_course_type.val) ? validate.response.highest_course_type.msg : ''"
              >
                <v-autocomplete
                  id="label-course-type"
                  v-model="highest_education.course_type"
                  :items="course_types"
                  item-value="value"
                  item-text="text"
                  placeholder="Course type"
                  @input="validate.checkIfEmpty(highest_education.course_type, 'highest_course_type', 'Select course type')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="Passing year"
                required
                :error="(typeof validate.response.highest_passout != 'undefined' && !validate.response.highest_passout.val) ? validate.response.highest_passout.msg : ''"
              >
                <v-text-field
                  type="month"
                  v-model="highest_passout"
                  name="year"
                  placeholder="Passing year"
                  @input="validate.checkIfEmpty(highest_passout, 'highest_passout', 'Select passout year')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="Marks"
                required
                :error="(typeof validate.response.highest_marks != 'undefined' && !validate.response.highest_marks.val) ? validate.response.highest_marks.msg : ''"
              >
                <input
                  type="number"
                  v-model="highest_education.mark"
                  name="Marks"
                  min="0"
                  max="100"
                  class="hc-field-input"
                  placeholder="Marks"
                  @input="validate.checkIfEmpty(highest_education.mark, 'highest_marks', 'Enter mark')"
                >
              </ProfileEditItem>
            </ProfileDetailGrid>
            <p v-if="highqual_error" class="hc-profile-edit-form__error">{{ highqual_err_msg }}</p>
            <ProfileEditFooter @cancel="cancelHighQualification">
              <template #save>
                <button type="submit" class="hc-profile-edit__save">Save</button>
              </template>
            </ProfileEditFooter>
          </div>
        </form>
      </div>
    </div>
    <div class="hc-panel__section">
      <div class="hc-panel__section-head">
        <h3>More qualifications</h3>
        <ProfileActionBtn variant="add" id="kl" @click="addMoreQuali">Add</ProfileActionBtn>
      </div>
      <div class="hc-panel__section-body hc-profile-details">
        <form @submit="updateMoreQualification">
          <div id="l" class="hc-profile-edit-form" v-if="add_moreQualification">
            <ProfileDetailGrid>
              <ProfileEditItem
                label="Course"
                required
                :error="(typeof validate.response.more_course != 'undefined' && !validate.response.more_course.val) ? validate.response.more_course.msg : ''"
              >
                <v-autocomplete
                  v-model="more_qualification.course_id"
                  :searchable="true"
                  :items="courses"
                  item-text="text"
                  item-value="id"
                  placeholder="Course"
                  @change="getSpecifications"
                  @input="validate.checkIfEmpty(more_qualification.course_id, 'more_course', 'Enter course')"
                  outlined
                  dense
                  hide-details
                >
                  <template slot="item" slot-scope="data">
                    <template>
                      <v-list-item-content>{{ data.item.text }}</v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </ProfileEditItem>
              <ProfileEditItem
                label="Specification"
                required
                :error="(typeof validate.response.more_speci != 'undefined' && !validate.response.more_speci.val) ? validate.response.more_speci.msg : ''"
              >
                <v-autocomplete
                  id="label-specialisation"
                  v-model="more_qualification.specification_id"
                  :items="spec"
                  item-value="value"
                  item-text="text"
                  placeholder="Specification"
                  @input="validate.checkIfEmpty(more_qualification.specification_id, 'more_speci', 'Enter specification')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="State"
                required
                :error="(typeof validate.response.more_state != 'undefined' && !validate.response.more_state.val) ? validate.response.more_state.msg : ''"
              >
                <v-autocomplete
                  v-model="more_qualification.state_id"
                  :items="states"
                  item-text="text"
                  item-value="id"
                  placeholder="State"
                  @change="getInstitutes"
                  @input="validate.checkIfEmpty(more_qualification.state_id, 'more_state', 'Enter state')"
                  clearable
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="College"
                required
                :error="(typeof validate.response.more_university != 'undefined' && !validate.response.more_university.val) ? validate.response.more_university.msg : ''"
              >
                <v-autocomplete
                  id="label-universities"
                  v-model="more_qualification.institute_id"
                  :items="institutes"
                  item-value="value"
                  item-text="text"
                  placeholder="College"
                  @input="validate.checkIfEmpty(more_qualification.institute_id, 'more_university', 'Select College')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="Course type"
                required
                :error="(typeof validate.response.more_course_type != 'undefined' && !validate.response.more_course_type.val) ? validate.response.more_course_type.msg : ''"
              >
                <v-autocomplete
                  id="label-course-type"
                  v-model="more_qualification.course_type"
                  :items="course_types"
                  item-value="value"
                  item-text="text"
                  placeholder="Course type"
                  @input="validate.checkIfEmpty(more_qualification.course_type, 'more_course_type', 'Select course type')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="Passing year"
                required
                :error="(typeof validate.response.more_passout != 'undefined' && !validate.response.more_passout.val) ? validate.response.more_passout.msg : ''"
              >
                <v-text-field
                  type="month"
                  v-model="more_passout"
                  name="year"
                  placeholder="Passing year"
                  @input="validate.checkIfEmpty(more_passout, 'more_passout', 'Select passout year')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="Marks"
                required
                :error="(typeof validate.response.more_marks != 'undefined' && !validate.response.more_marks.val) ? validate.response.more_marks.msg : ''"
              >
                <input
                  type="number"
                  v-model="more_qualification.mark"
                  name="Marks"
                  min="0"
                  max="100"
                  class="hc-field-input"
                  placeholder="Marks"
                  @input="validate.checkIfEmpty(more_qualification.mark, 'more_marks', 'Enter mark')"
                >
              </ProfileEditItem>
            </ProfileDetailGrid>
            <p v-if="morequal_error" class="hc-profile-edit-form__error">{{ morequal_err_msg }}</p>
            <ProfileEditFooter @cancel="cancelMoreQualification">
              <template #save>
                <button type="submit" class="hc-profile-edit__save">Save</button>
              </template>
            </ProfileEditFooter>
          </div>
          <div v-if="more_quals&&more_quals.length" class="hc-record-list">
            <ProfileRecordCard
              v-for="qual in more_quals"
              :key="qual.id"
              :title="qual.course ? qual.course.course_name : 'Qualification'"
              :subtitle="qual.institute ? qual.institute.institute_name : ''"
            >
              <template #actions>
                <ProfileActionBtn variant="delete" @click.prevent="removeQualification(qual.id)">Delete</ProfileActionBtn>
              </template>
              <ProfileDetailGrid>
                <ProfileDetailItem label="Specification" :value="qual.branch && qual.branch.branch_name" required />
                <ProfileDetailItem label="State" :value="qual.state && qual.state.state_name" required />
                <ProfileDetailItem label="Course type" :value="qual.course_type ? getCourseType(qual.course_type) : ''" required />
                <ProfileDetailItem label="Passing year" :value="qual.passout_year" required />
                <ProfileDetailItem label="Marks" :value="qual.aggregate_marks ? `${qual.aggregate_marks}%` : ''" required />
              </ProfileDetailGrid>
            </ProfileRecordCard>
          </div>
          <div class="hc-panel__empty hc-panel__empty--compact" v-else>
            <p class="mb-0">No additional qualifications added.</p>
          </div>
        </form>
      </div>
    </div>
    <div class="hc-panel__section">
      <div class="hc-panel__section-head">
        <h3>12th details</h3>
        <ProfileActionBtn variant="edit" id="mn" @click="toggleXiithEdit">Edit</ProfileActionBtn>
      </div>
      <div class="hc-panel__section-body hc-profile-details">
        <form @submit="updateXiithDetails">
          <div id="m" v-if="!edit_xiith">
            <ProfileDetailGrid>
              <ProfileDetailItem label="School" :value="xiith_details.xiith_school_name" required wide />
              <ProfileDetailItem label="Board" :value="xiith_details.xiith_board_name" required />
              <ProfileDetailItem label="Passing year" :value="xiith_details.xiith_passout_year" required />
              <ProfileDetailItem label="Marks" :value="xiith_details.xiith_marks ? `${xiith_details.xiith_marks}%` : ''" required />
            </ProfileDetailGrid>
          </div>
          <div id="n" class="hc-profile-edit-form" v-if="edit_xiith">
            <ProfileDetailGrid>
              <ProfileEditItem
                label="School"
                required
                wide
                :error="(typeof validate.response.xii_school != 'undefined' && !validate.response.xii_school.val) ? validate.response.xii_school.msg : ''"
              >
                <input
                  type="text"
                  v-model="xiith_details.xiith_school_name"
                  name="School"
                  class="hc-field-input"
                  placeholder="School"
                  @input="validate.checkIfEmpty(xiith_details.xiith_school_name, 'xii_school', 'Enter school')"
                >
              </ProfileEditItem>
              <ProfileEditItem
                label="Board"
                required
                :error="(typeof validate.response.xii_board != 'undefined' && !validate.response.xii_board.val) ? validate.response.xii_board.msg : ''"
              >
                <input
                  type="text"
                  v-model="xiith_details.xiith_board_name"
                  name="Board"
                  class="hc-field-input"
                  placeholder="Board"
                  @input="validate.checkIfEmpty(xiith_details.xiith_board_name, 'xii_board', 'Enter board')"
                >
              </ProfileEditItem>
              <ProfileEditItem
                label="Passing year"
                required
                :error="(typeof validate.response.xii_passout != 'undefined' && !validate.response.xii_passout.val) ? validate.response.xii_passout.msg : ''"
              >
                <v-text-field
                  type="month"
                  v-model="xiith_passout"
                  name="year"
                  placeholder="Passing year"
                  @input="validate.checkIfEmpty(xiith_passout, 'xii_passout', 'Select passout year')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="Marks"
                required
                :error="(typeof validate.response.xii_marks != 'undefined' && !validate.response.xii_marks.val) ? validate.response.xii_marks.msg : ''"
              >
                <input
                  type="number"
                  v-model="xiith_details.xiith_marks"
                  name="Marks"
                  min="0"
                  max="100"
                  class="hc-field-input"
                  placeholder="Marks"
                  @input="validate.checkIfEmpty(xiith_details.xiith_marks, 'xii_marks', 'Enter mark')"
                >
              </ProfileEditItem>
            </ProfileDetailGrid>
            <p v-if="xii_error" class="hc-profile-edit-form__error">{{ xii_err_msg }}</p>
            <ProfileEditFooter @cancel="cancelXiithEdit">
              <template #save>
                <button type="submit" class="hc-profile-edit__save">Save</button>
              </template>
            </ProfileEditFooter>
          </div>
        </form>
      </div>
    </div>
    <div class="hc-panel__section">
      <div class="hc-panel__section-head">
        <h3>10th details</h3>
        <ProfileActionBtn variant="edit" id="op" @click="toggleXthEdit">Edit</ProfileActionBtn>
      </div>
      <div class="hc-panel__section-body hc-profile-details">
        <form @submit="updateXthDetails">
          <div id="o" v-if="!edit_xth">
            <ProfileDetailGrid>
              <ProfileDetailItem label="School" :value="xth_details.xth_school_name" required wide />
              <ProfileDetailItem label="Board" :value="xth_details.xth_board_name" required />
              <ProfileDetailItem label="Passing year" :value="xth_details.xth_passout_year" required />
              <ProfileDetailItem label="Marks" :value="xth_details.xth_marks ? `${xth_details.xth_marks}%` : ''" required />
            </ProfileDetailGrid>
          </div>

          <div id="p" class="hc-profile-edit-form" v-if="edit_xth">
            <ProfileDetailGrid>
              <ProfileEditItem
                label="School"
                required
                wide
                :error="(typeof validate.response.x_school != 'undefined' && !validate.response.x_school.val) ? validate.response.x_school.msg : ''"
              >
                <input
                  type="text"
                  v-model="xth_details.xth_school_name"
                  name="School"
                  class="hc-field-input"
                  placeholder="School"
                  @input="validate.checkIfEmpty(xth_details.xth_school_name, 'x_school', 'Enter school')"
                >
              </ProfileEditItem>
              <ProfileEditItem
                label="Board"
                required
                :error="(typeof validate.response.x_board != 'undefined' && !validate.response.x_board.val) ? validate.response.x_board.msg : ''"
              >
                <input
                  type="text"
                  v-model="xth_details.xth_board_name"
                  name="Board"
                  class="hc-field-input"
                  placeholder="Board"
                  @input="validate.checkIfEmpty(xth_details.xth_board_name, 'x_board', 'Enter board')"
                >
              </ProfileEditItem>
              <ProfileEditItem
                label="Passing year"
                required
                :error="(typeof validate.response.x_passout != 'undefined' && !validate.response.x_passout.val) ? validate.response.x_passout.msg : ''"
              >
                <v-text-field
                  type="month"
                  v-model="xth_passout"
                  name="year"
                  placeholder="Passing year"
                  @input="validate.checkIfEmpty(xth_passout, 'x_passout', 'Select passout year')"
                  outlined
                  dense
                  hide-details
                />
              </ProfileEditItem>
              <ProfileEditItem
                label="Marks"
                required
                :error="(typeof validate.response.x_marks != 'undefined' && !validate.response.x_marks.val) ? validate.response.x_marks.msg : ''"
              >
                <input
                  type="number"
                  v-model="xth_details.xth_marks"
                  name="Marks"
                  min="0"
                  max="100"
                  class="hc-field-input"
                  placeholder="Marks"
                  @input="validate.checkIfEmpty(xth_details.xth_marks, 'x_marks', 'Enter mark')"
                >
              </ProfileEditItem>
            </ProfileDetailGrid>
            <p v-if="x_error" class="hc-profile-edit-form__error">{{ x_err_msg }}</p>
            <ProfileEditFooter @cancel="cancelXthEdit">
              <template #save>
                <button type="submit" class="hc-profile-edit__save">Save</button>
              </template>
            </ProfileEditFooter>
          </div>
        </form>
      </div>
    </div>
    <ProfileToast ref="profileToast" />
  </DashboardPanel>
</template>

<script>
import Actions from '../libraries/apiActions.js';
import validation from '../libraries/validFormat' ;
import DashboardPanel from './Dashboard/DashboardPanel.vue';
import ProfileDetailGrid from './Dashboard/ProfileDetailGrid.vue';
import ProfileDetailItem from './Dashboard/ProfileDetailItem.vue';
import ProfileRecordCard from './Dashboard/ProfileRecordCard.vue';
import ProfileToast from './Dashboard/ProfileToast.vue';
import ProfileActionBtn from './Dashboard/ProfileActionBtn.vue';
import ProfileEditFooter from './Dashboard/ProfileEditFooter.vue';
import ProfileEditItem from './Dashboard/ProfileEditItem.vue';
import '../assets/hire.css';
export default {
    name:'EducationDetails',
    components: { DashboardPanel, ProfileDetailGrid, ProfileDetailItem, ProfileRecordCard, ProfileToast, ProfileActionBtn, ProfileEditFooter, ProfileEditItem },
    props: ["user"],
    data: function() {
      return {
        validate: new validation(),
        action: new Actions(),
        states:[],
        courses:[],
        spec:[],
        institutes:[],
        xiith_passout:null,
        xth_passout:null,
        highest_passout:null,
        more_passout:null,
        can_update:0,
        edit_xth:false,
        edit_xiith:false,
        edit_highQualification:false,
        edit_moreQualification:false,
        add_moreQualification:false,
        c_type:null,
        set_course:null,
        set_specification:null,
        set_state:null,
        set_institute:null,
        highest_education:{
          course_id : null,
          specification : null,
          state_id : null,
          institute_id : null,
          course_type : null,
          passout_year : null,
          passout_month:null,
          mark : null
        },
        highest_qualification:{
          course:null,
          specification : null,
          state:null,
          institute:null,
          course_type:null
        },
        more_qualification:{
          course_id:null,
          specification_id:null,
          state_id:null,
          institute_id:null,
          course_type:null,
          passing_year:null,
          passing_month:null,
          mark:null
        },
        more_quals:[],
        xiith_details:{
          xiith_school_name:null,
          xiith_board_name:null,
          xiith_passout_year:null,
          xiith_passout_month:null,
          xiith_marks:null,
        },
        xth_details:{
          xth_school_name:null,
          xth_board_name:null,
          xth_passout_year:null,
          xth_passout_month:null,
          xth_marks:null,
        },
        course_types:[
          {value:1, text:'Full time'},
          {value:2, text:'Part time',}
        ],
        highqual_error : false,
        highqual_err_msg : null,
        morequal_error : false,
        morequal_err_msg : null,
        xii_error : false,
        xii_err_msg : null,
        x_error : false,
        x_err_msg : null,
      }
    },
    beforeMount(){
      this.getStates();
      this.setHighestQualification();
      // this.setMoreQualification();
      // this.states = this.$store.state.states.locations.locations;
      this.courses = this.$store.state.courses.courses.courses;
      // this.xth_details = ;
      this.setXiithDetails();
      this.setXthDetails();
      this.more_quals = this.user?.more_qualification;
    },
    methods: {
      addMoreQuali(e){
        e.preventDefault();
        if (this.add_moreQualification) {
          this.cancelMoreQualification();
        } else if (this.more_quals.length < 5) {
          this.add_moreQualification = true;
        }
      },
      getCourseType(data){
        this.course_types.forEach(type => {
          if(type.value == data){
            this.c_type = type.text;
          }
        });
        return this.c_type;
      },
      getCourse(data){
        this.courses.forEach(course => {
          if(course.id == data){
            this.set_course =course.text;
          }
        });
        return this.set_course;
      },
      getState(data){
        this.states.forEach(state => {
          if(state.id == data){
            this.set_state = state.text;
          }
        });
        return this.set_state;
      },
      getSpecification(data){
        this.spec.forEach(s => {
          if(s.value == data){
            this.set_specification = s.text;
          }
        });
        return this.set_specification;
      },
      getInstitute(data){
        this.institutes.forEach(uni => {
          if(uni.value == data){
            this.set_institute = uni.text;
          }
        });
        return this.set_institute;
      },
      editHighQualification(){
        if (this.edit_highQualification) {
          this.cancelHighQualification();
        } else {
          this.edit_highQualification = true;
          this.getSpecifications();
        }
      },
      setHighestQualification(){
        console.log(this.user);
        this.highest_education.course_id = (this.user.high_qualification?.course?.course_id)?this.user.high_qualification?.course?.course_id:null;
        this.highest_education.specification =  (this.user.high_qualification?.branch?.bid)?this.user.high_qualification?.branch?.bid:null;
        console.log(this.highest_education.specification);
        this.getSpecifications();
        this.highest_education.state_id = (this.user.high_qualification?.state?.state_id)?this.user.high_qualification?.state?.state_id:null;
        this.getInstitutes();
        this.highest_education.institute_id = (this.user.high_qualification?.institute?.institute_id)?this.user.high_qualification?.institute?.institute_id:null;
        this.highest_education.course_type = (this.user.high_qualification?.course_type)?this.user.high_qualification?.course_type:null;
        this.highest_education.passout_year = (this.user.high_qualification?.passout_year)?this.user.high_qualification?.passout_year:null;
        this.highest_education.passout_month = (this.user.high_qualification?.passout_month)?this.user.high_qualification?.passout_month:null;
        this.highest_education.mark = (this.user.high_qualification?.aggregate_marks)?this.user.high_qualification?.aggregate_marks:null;
        this.highest_passout = (this.highest_education.passout_month && this.highest_education.passout_year)? ((this.highest_education.passout_month == '11' ||this.highest_education.passout_month == '12')?this.highest_education.passout_year+'-'+this.highest_education.passout_month:this.highest_education.passout_year+'-0'+this.highest_education.passout_month): null;
        this.highest_qualification.specification = (this.user.high_qualification?.branch?.bid)?this.user.high_qualification?.branch?.branch_name:null;
        this.highest_qualification.state = (this.user.high_qualification?.state?.state_name)?this.user.high_qualification?.state?.state_name:null;
        this.highest_qualification.institute = (this.user.high_qualification?.institut?.institute_name)?this.user.high_qualification?.institute?.institute_name:null;
        this.course_types.forEach(type => {
          if(type.value == this.highest_education.course_type){
            this.highest_qualification.course_type = type.text;
          }
        });
      },
      setXthDetails(){
        this.xth_details.xth_school_name = (this.user.xth_details?.xth_school_name) ? this.user.xth_details?.xth_school_name : null;
        this.xth_details.xth_board_name = (this.user.xth_details?.xth_board_name) ? this.user.xth_details?.xth_board_name : null;
        this.xth_details.xth_passout_year = (this.user.xth_details?.xth_passout_year) ? this.user.xth_details?.xth_passout_year : null;
        this.xth_details.xth_passout_month = (this.user.xth_details?.xth_passout_month) ? this.user.xth_details?.xth_passout_month : null;
        this.xth_details.xth_marks = (this.user.xth_details?.xth_marks) ? this.user.xth_details?.xth_marks : null;
        this.xth_passout = (this.xth_details.xth_passout_month && this.xth_details.xth_passout_year)? ((this.xth_details.xth_passout_month == '11' ||this.xth_details.xth_passout_month == '12')?this.xth_details.xth_passout_year+'-'+this.xth_details.xth_passout_month:this.xth_details.xth_passout_year+'-0'+this.xth_details.xth_passout_month): null;
      },
      setXiithDetails(){
        this.xiith_details.xiith_school_name = (this.user.xiith_details?.xiith_school_name) ? this.user.xiith_details?.xiith_school_name : null;
        this.xiith_details.xiith_board_name = (this.user.xiith_details?.xiith_board_name) ? this.user.xiith_details?.xiith_board_name : null;
        this.xiith_details.xiith_passout_year = (this.user.xiith_details?.xiith_passout_year) ? this.user.xiith_details?.xiith_passout_year : null;
        this.xiith_details.xiith_passout_month = (this.user.xiith_details?.xiith_passout_month) ? this.user.xiith_details?.xiith_passout_month : null;
        this.xiith_details.xiith_marks = (this.user.xiith_details?.xiith_marks) ? this.user.xiith_details?.xiith_marks : null;
        this.xiith_passout = (this.xiith_details.xiith_passout_month && this.xiith_details.xiith_passout_year)? ((this.xiith_details.xiith_passout_month == '11' ||this.xiith_details.xiith_passout_month == '12')?this.xiith_details.xiith_passout_year+'-'+this.xiith_details.xiith_passout_month:this.xiith_details.xiith_passout_year+'-0'+this.xiith_details.xiith_passout_month): null;
      },
      getStates(){
        this.action.getStates().then(data => {
          data.states.forEach((element) => {
            this.states.push({
              id: element.state_id,
              text:element.state_name
            })
          })
        })
      },
      getSpecifications: function () {
        this.spec = [];
        let spec_id = (this.edit_highQualification)?this.highest_education.course_id:((this.add_moreQualification)?this.more_qualification.course_id:this.highest_education.course_id);
        this.action.getSpec(spec_id).then((data) => {
          data.specifications.forEach((element) => {
            this.spec.push({
              value: element.bid,
              text: element.branch_name,
            });
          });
        });
      },
      getInstitutes: function () {
        this.institutes = [];
        let state_id = (this.edit_highQualification)?this.highest_education.state_id:((this.add_moreQualification)?this.more_qualification.state_id:null);
        this.action.getInstitutes({state_id:state_id}).then((data) => {
          if(data.institutes){
            data.institutes.forEach((element) => {
              if(element.institute_name){
                this.institutes.push({
                  value: element.institute_id,
                  text:element.institute_name
                })
              }
            })
          }
        })
      },
      updateHighestQualification(e){
        e.preventDefault();
        this.can_update = 0;
        this.highqual_error = false;
        this.highqual_err_msg = null;
        if(this.validate.checkIfEmpty(this.highest_education.course_id, "highest_course", 'Enter course')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.highest_education.specification, "highest_speci", 'Enter specification')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.highest_education.state_id, "highest_state", 'Enter state')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.highest_education.institute_id, "highest_university", 'Select college')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.highest_education.course_type, "highest_course_type", 'Select course type')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.highest_passout, "highest_passout", 'Select passout year')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.highest_education.mark, "highest_marks", 'Enter mark')?.val === false){
          this.can_update++;
        }

        if(this.can_update == 0){
          this.highest_education.passout_year = this.highest_passout.split('-')[0];
          this.highest_education.passout_month = this.highest_passout.split('-')[1];
          let token = this.$cookies.get("hire-seeker").token;
          this.action.updateHighestQualification(this.highest_education,token).then(data =>{
            if(data.message == 'High Qualification updated'){
              this.edit_highQualification = false;
              this.$refs.profileToast.show('Highest qualification saved');
            }else{
              this.highqual_error = true;
              this.highqual_err_msg = "Network error! Please check your internet connection.";
            }
          }).catch(err =>{
            console.log(err);
            this.highqaul_error = true;
            if(window.navigator.onLine){
              this.highqual_err_msg = "System error! Please try again.";
            }else{
              this.highqual_err_msg = "Network error! Please check your internet connection.";
            }
          })
        }else{
          this.highqual_error = true;
          this.highqual_err_msg = "Fill all mandatory fields.";
        }
      },
      updateMoreQualification(e){
        e.preventDefault();
        this.can_update = 0;
        this.morequal_error = false;
        this.morequal_err_msg = null;

        if(this.validate.checkIfEmpty(this.more_qualification.course_id, "more_course", 'Enter course')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.more_qualification.specification_id, "more_speci", 'Enter specification')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.more_qualification.state_id, "more_state", 'Enter state')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.more_qualification.institute_id, "more_university", 'Select college')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.more_qualification.course_type, "more_course_type", 'Select course type')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.more_passout, "more_passout", 'Select passout year')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.more_qualification.mark, "more_marks", 'Enter mark')?.val === false){
          this.can_update++;
        }

        if(this.can_update == 0){
          this.more_qualification.passing_year = this.more_passout.split('-')[0];
          this.more_qualification.passing_month = this.more_passout.split('-')[1];
          let token = this.$cookies.get("hire-seeker").token;
          this.action.updateMoreQualification(this.more_qualification,token).then(res =>{
            if(res.message == 'More Qualification updated'){
              this.edit_moreQualification = false;
              this.add_moreQualification = false;
              this.$refs.profileToast.show('Qualification added');
              this.more_quals.push(res.data);
              this.resetFields();
              // location.reload();
            }else{
              this.morequal_error = true;
              this.morequal_err_msg = "System error! Please try again.";
            }
          }).catch(err =>{
            console.log(err);
            this.morequal_error = true;
            if(window.navigator.onLine){
              this.morequal_err_msg = "System error! Please try again.";
            }else{
              this.morequal_err_msg = "Network error! Please check your internet connection.";
            }
          })
        }else{
          this.moreqaul_error = true;
          this.moreqaul_err_msg = "Fill all mandatory fields.";
        }
      },
      updateXiithDetails(e){
        e.preventDefault();
        this.can_update = 0;
        this.xii_error = false;
        this.xii_err_msg = null;
        
        if(this.validate.checkIfEmpty(this.xiith_details.xiith_school_name, "xii_school", 'Enter school')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.xiith_details.xiith_board_name, "xii_board", 'Enter board')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.xiith_passout, "xii_passout", 'Select passout year')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.xiith_details.xiith_marks, "xii_marks", 'Enter mark')?.val === false){
          this.can_update++;
        }

        if(this.can_update == 0){
          this.xiith_details.xiith_passout_year = this.xiith_passout.split('-')[0];
          this.xiith_details.xiith_passout_month = this.xiith_passout.split('-')[1];
          let token = this.$cookies.get("hire-seeker").token;
          this.action.updateXiithDetails(this.xiith_details,token).then(data =>{
            if(data.message == '12th School details updated'){
              this.edit_xiith = false;
              this.$refs.profileToast.show('12th details saved');
            }else{
              this.xii_error = true;
              this.xii_err_msg = "System error! Please try again.";
            }
          }).catch(err =>{
            console.log(err);
            this.xii_error = true;
            if(window.navigator.onLine){
              this.xii_err_msg = "System error! Please try again.";
            }else{
              this.xii_err_msg = "Network error! Please check your internet connection.";
            }
          })
        }else{
          this.xii_error = true;
          this.xii_err_msg = "Fill all mandatory fields.";
        }
      },
      updateXthDetails(e){
        e.preventDefault();
        this.can_update = 0;
        this.x_error = false;
        this.x_err_msg= null;

        if(this.validate.checkIfEmpty(this.xth_details.xth_school_name, "x_school", 'Enter school')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.xth_details.xth_board_name, "x_board", 'Enter board')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.xth_passout, "x_passout", 'Select passout year')?.val === false){
          this.can_update++;
        }
        if(this.validate.checkIfEmpty(this.xth_details.xth_marks, "x_marks", 'Enter mark')?.val === false){
          this.can_update++;
        }

        if(this.can_update == 0){
          this.xth_details.xth_passout_year = this.xth_passout.split('-')[0];
          this.xth_details.xth_passout_month = this.xth_passout.split('-')[1];
          let token = this.$cookies.get("hire-seeker").token;
          this.action.updateXthDetails(this.xth_details,token).then(data =>{
            if(data.message == '10th School details updated'){
              this.edit_xth = false;
              this.$refs.profileToast.show('10th details saved');
            }else{
              this.x_error = true;
              this.x_err_msg = "System error! Please try again.";
            }
          }).catch(err =>{
            console.log(err);
            this.x_error = true;
            if(window.navigator.onLine){
              this.x_err_msg = "System error! Please try again.";
            }else{
              this.x_err_msg = "Network error! Please check your internet connection.";
            }
          })
        }else{
          this.x_error = true;
          this.x_err_msg = "Fill all mandatory fields.";
        }
      },
      removeQualification(id){
        this.action.removeQualification(id,this.$cookies.get("hire-seeker").token).then(res => {
          if(res.message == 'Qualification deleted successfully'){
            this.more_quals = this.more_quals.filter(qual => qual.id !== id);
            this.$refs.profileToast.show('Qualification removed', 'danger');
          }
        });
      },
      resetFields(){
        this.more_qualification.course_id=null,
        this.more_qualification.specification_id=null,
        this.more_qualification.state_id=null,
        this.more_qualification.institute_id=null,
        this.more_qualification.course_type=null,
        this.more_qualification.passing_year=null,
        this.more_qualification.passing_month=null,
        this.more_qualification.mark=null
      },
      cancelHighQualification() {
        this.setHighestQualification();
        this.highqual_error = false;
        this.highqual_err_msg = null;
        this.edit_highQualification = false;
      },
      cancelMoreQualification() {
        this.resetFields();
        this.more_passout = null;
        this.morequal_error = false;
        this.morequal_err_msg = null;
        this.add_moreQualification = false;
      },
      cancelXiithEdit() {
        this.setXiithDetails();
        this.xii_error = false;
        this.xii_err_msg = null;
        this.edit_xiith = false;
      },
      cancelXthEdit() {
        this.setXthDetails();
        this.x_error = false;
        this.x_err_msg = null;
        this.edit_xth = false;
      },
      toggleXiithEdit() {
        if (this.edit_xiith) {
          this.cancelXiithEdit();
        } else {
          this.edit_xiith = true;
        }
      },
      toggleXthEdit() {
        if (this.edit_xth) {
          this.cancelXthEdit();
        } else {
          this.edit_xth = true;
        }
      }
    }

}
</script>
